"use strict";function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const t=e(require("styled-components")).default.section`
    .PlannerQuestion-input {
        border: solid 1px ${({theme:e})=>e.colors.grey[300]};
        border-radius: 2px;
        padding: ${({theme:e})=>e.spacing.medium};
        width: 50%;
        min-width: 175px;
        margin: auto;
        text-align: center;

        &:focus-visible {
            outline: solid 1px ${({theme:e})=>e.colors.grey[300]};
        }

        &::placeholder {
            color: ${({theme:e})=>e.colors.grey[500]};
        }
    }
`;module.exports=t;
//# sourceMappingURL=styles.js.map
